import script from "./cardUcapan.vue?vue&type=script&setup=true&lang=js"
export * from "./cardUcapan.vue?vue&type=script&setup=true&lang=js"

import "./cardUcapan.vue?vue&type=style&index=0&id=04cec2f5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04cec2f5"]])

export default __exports__